var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFa6BrandsSquareXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fa6-brands:square-x-twitter"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.04794 2.5C2.7347 2.5 1.66699 3.46094 1.66699 4.64286V15.3571C1.66699 16.5391 2.7347 17.5 4.04794 17.5H15.9527C17.2659 17.5 18.3337 16.5391 18.3337 15.3571V4.64286C18.3337 3.46094 17.2659 2.5 15.9527 2.5H4.04794ZM15.1008 5.3125L11.2392 9.28348L15.7816 14.6875H12.225L9.44229 11.4096L6.25404 14.6875H4.48693L8.61639 10.4386L4.26 5.3125H7.90583L10.4244 8.30915L13.3337 5.3125H15.1008ZM13.6945 13.7366L7.37384 6.21317H6.32101L12.7124 13.7366H13.6908H13.6945Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFa6BrandsSquareXTwitter);
export default __webpack_public_path__ + "static/media/fa6-brands_square-x-twitter.48a3f60ea3b740ec5bf30a58cb4b5e52.svg";
export { ForwardRef as ReactComponent };